import { useEffect } from 'react';

import { Theme, useUIStore } from '@/stores';

/**
 * Hook to manage application theme (light, dark, or system).
 *
 * @returns { object } Returns current theme and setter function.
 */
export const useTheme = () => {
  const { theme, setTheme } = useUIStore();

  useEffect(() => {
    const root = globalThis.document.documentElement;

    const applyTheme = (resolvedTheme: Exclude<Theme, Theme.System>) => {
      root.classList.remove(Theme.Light, Theme.Dark);
      root.classList.add(resolvedTheme);
    };

    if (theme === Theme.System) {
      const systemTheme = globalThis.matchMedia('(prefers-color-scheme: dark)').matches ? Theme.Dark : Theme.Light;
      applyTheme(systemTheme);

      const mediaQuery = globalThis.matchMedia('(prefers-color-scheme: dark)');

      const handleChange = (e: MediaQueryListEvent) => {
        applyTheme(e.matches ? Theme.Dark : Theme.Light);
      };

      mediaQuery.addEventListener('change', handleChange);

      return () => mediaQuery.removeEventListener('change', handleChange);
    } else {
      applyTheme(theme);
    }
  }, [theme]);

  return {
    theme,
    setTheme,
  };
};
